import { useMemo } from 'react';
import { UserAttributeKeys, useUserAttribute } from '../userAttributes';
import { getGenericRecommendedSoftware, getRecommendedSoftwareByField, getRecommendedSoftwareByLanguage, userCompletedContentAfterQuiz } from './recommendationsUtils';
import getLang from 'LearningCenterUI/utils/getLang';
import { SOFTWARE_TABS } from './recommendationsConstants';
import { usePreviouslySelectedTabStore } from './recommendationsStore';
import { useSavedLearningInterest } from '../wizard';
import { useRecommendationsTopicPreference } from './recommendationsQueries';
import { useAllProgress } from '../userProgress';
export const usePrioritizeInterestRecommendations = () => {
  const {
    allProgress: {
      contentProgress
    },
    allProgressLoading: isRequestingProgress
  } = useAllProgress();
  const {
    userAttribute: quizCompletionDate,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const prioritizeInterestRecommendations = useMemo(() => {
    if (isRequestingProgress || userAttributeLoading) return undefined;
    return !!quizCompletionDate && !userCompletedContentAfterQuiz(quizCompletionDate, contentProgress);
  }, [contentProgress, isRequestingProgress, quizCompletionDate, userAttributeLoading]);
  const isLoading = prioritizeInterestRecommendations === undefined;
  return {
    prioritizeInterestRecommendations,
    isLoading,
    hasError: userAttributesError
  };
};
export const useSoftwareRecommendationsTabs = () => {
  const {
    selectedCategoryGroup,
    selectedToolsGroup,
    hasLearningInterest,
    isLoadingLearningInterest
  } = useSavedLearningInterest();
  const {
    previouslySelectedTab
  } = usePreviouslySelectedTabStore();
  const {
    recommendationsTopicPreference,
    recommendationsTopicPreferenceLoading
  } = useRecommendationsTopicPreference();
  const {
    topic
  } = recommendationsTopicPreference || {};
  const recommendationsTopic = topic;
  const defaultSelectedTab = useMemo(() => {
    if (previouslySelectedTab) return previouslySelectedTab;else if (hasLearningInterest) {
      switch (selectedCategoryGroup || selectedToolsGroup) {
        case 'MARKETING':
        case 'MARKETING_HUB_TOOLS':
          return 'marketing';
        case 'SALES':
        case 'SALES_HUB_TOOLS':
          return 'sales';
        case 'SERVICE':
        case 'SERVICE_SUPPORT':
        case 'SERVICE_HUB_TOOLS':
          return 'services-support';
        default:
          return 'other';
      }
    } else if (recommendationsTopic && SOFTWARE_TABS.includes(recommendationsTopic)) {
      return recommendationsTopic;
    }
    return 'other';
  }, [previouslySelectedTab, hasLearningInterest, recommendationsTopic, selectedCategoryGroup, selectedToolsGroup]);
  const isLoading = isLoadingLearningInterest || recommendationsTopicPreferenceLoading;
  return {
    isLoading,
    defaultSelectedTab
  };
};
export const useSoftwareRecommendationsContent = (selectedTab, maxResults = 6) => {
  const language = getLang();
  const contentToUse = useMemo(() => {
    let tempContentList;
    if (language === 'en') {
      tempContentList = getRecommendedSoftwareByField(selectedTab);
    } else {
      tempContentList = getRecommendedSoftwareByLanguage(language);
    }
    if (!tempContentList) tempContentList = getGenericRecommendedSoftware();
    const allButton = tempContentList.find(({
      type
    }) => type === 'all');
    let slicedList = tempContentList.slice(0, maxResults);
    if (!slicedList.find(({
      type
    }) => type === 'all') && allButton) {
      slicedList = [...slicedList.slice(0, -1), allButton];
    }
    return slicedList;
  }, [language, maxResults, selectedTab]);
  return contentToUse;
};